import type { SlideProps } from "@/engine/app/offsite-config";

const ROWS = [
  {
    beispiel: "Zählerstände aus dem Portal in kVASy übertragen",
    werkzeug: "RPA / Webservice — festes Drehbuch, null Kreativität nötig",
  },
  {
    beispiel: "Absatzmengen fürs nächste Jahr abschätzen",
    werkzeug: "ML — Muster aus historischen Daten",
  },
  {
    beispiel: "Antwort auf eine Marktpartner-Anfrage formulieren",
    werkzeug: "LLM — Sprache verstehen und erzeugen",
  },
  {
    beispiel: "Zwei Systeme abgleichen, Differenzen ins dritte schreiben",
    werkzeug: "LLM + Webservices kombiniert — genau euer Workshop-Thema",
  },
];

export function Slide08Werkzeug(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Werkzeugkasten</div>
        <h1 className="deck-title rise rise-2">
          Welches Werkzeug <br />
          <span className="accent">für welche Aufgabe?</span>
        </h1>
        <p className="deck-sub rise rise-3">Mit Beispielen aus eurem Alltag.</p>
      </header>

      <div className="status-grid rise rise-4">
        <div className="status-headers">
          <div className="neg">Aufgabe aus der Netzwirtschaft</div>
          <div className="pos">Passendes Werkzeug</div>
        </div>
        {ROWS.map((r) => (
          <div key={r.beispiel} className="status-row">
            <div className="status-cell neg">
              <span className="status-mark neg">?</span>
              <span className="status-text">{r.beispiel}</span>
            </div>
            <div className="status-cell pos">
              <span className="status-mark pos">✓</span>
              <span className="status-text">{r.werkzeug}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
